export default __webpack_public_path__ + "3e22a5367c2e68d6e4ba56d2a827141e.woff2";